import React, { Component, PropType } from 'react';
import TableComponent from '../../commonComponents/TableComponent';
import NoDataFound from '../../commonComponents/NoDataFound';
import LoadingComponent from '../../commonComponents/LoadingComponent'
import axios from 'axios';
import base64 from 'base-64';
import { DBService } from '../../SummaryComponents/component/IndexedDB';
import { isEqual } from 'lodash';
// import { getParameters } from '../../../../adminpanel/components/commonComponents/Helper';
// import CallAPI from '../../../../adminpanel/components/commonComponents/AxiosHelper';

var localParams = {};
var leftDim, aboveDim = "";

class TableData extends React.Component{
    constructor(props) {
        super(props);
        this.state = {table: null,metricRange: '',i: 0, ...props},
        this._db = new DBService();
    }
    arePrevAndThisPropsEqual (prevProps, nextProps) {
        if (prevProps.breakUp == nextProps.breakUp && prevProps.category == nextProps.category && prevProps.categoryValue == nextProps.categoryValue && prevProps.selectedMetric == nextProps.selectedMetric && prevProps.startDate == nextProps.startDate && prevProps.endDate == nextProps.endDate && prevProps.metricRange == nextProps.metricRange && prevProps.drill == nextProps.drill && prevProps.period==nextProps.period && prevProps.transpose==nextProps.transpose && prevProps.kpiMonitoring == nextProps.kpiMonitoring && prevProps.periodComparison == nextProps.periodComparison && prevProps.multiDim == nextProps.multiDim && prevProps.exclude == nextProps.exclude && prevProps.include == nextProps.include && prevProps.sortOrder === nextProps.sortOrder && prevProps.limit === nextProps.limit && prevProps.kpiColumnConfig == nextProps.kpiColumnConfig && prevProps.globalFilters == nextProps.globalFilters && (prevProps.prevStartDate == nextProps.prevStartDate || prevProps.prevStartDate == nextProps?.allData?.props?.prevStartDate) && (prevProps.prevEndDate == nextProps?.prevEndDate || prevProps?.prevEndDate == nextProps?.allData?.props?.prevEndDate) && prevProps?.sortMetric == nextProps?.sortMetric && prevProps?.cagrPoint == nextProps?.cagrPoint)
            return true;
        else
            return false;
    }
    componentWillMount() {
        this.componentWillReceiveProps(this.props);
    }
    componentDidUpdate() {
        jQuery('[data-toggle="tooltip"]').tooltip();
    }
    componentDidCatch(error, info) {
        this.setState({
            pageError: true
        })
    }

    getAjaxRequest = (type, params, authorization_value, sessionId) => {
        switch (type) {
            case 'report':
            case 'table':
                return axios.get("/app/v1/trendChart", {
                    headers: {
                        Authorization: authorization_value,
                        'sessionId': sessionId
                    },
                    params: params
                })
                break;
            case 'summary':
            case 'total':
                return axios.get("/app/v1/trendChart", {
                    headers: {
                        Authorization: authorization_value,
                        'sessionId': sessionId
                    },
                    params: params
                })
                break;
        }
    }

    postAjaxRequest = (type, params, authorization_value, sessionId) => {
        const headers = {
            Authorization: authorization_value,
            'sessionId': sessionId
        }
        let encodedData = encodePostBody(params)
        if (type == 'table') {
            return axios.post('/app/v1/trendChart', encodedData, {
                headers: headers
            })
        }
    }

    stateSetFromResponse(data, totalResponse, nextProps, shortNameKPI=null) {
        let that = this
        if (data !== null) {
            var parsedResponse = JSON.parse(data.table);
            if (parsedResponse.data.explain) {
                questionExplain = parsedResponse.data.explain;
                jQuery("#questionExplain").html(questionExplain);
            }
            var response = parsedResponse
            var tableResponseCache = response
            var headers = response.headers;
            var property_sort_order = response.property_sort_order
            var cagrDate = response?.parameter_cache?.date
            var previousPeriodDate = response?.parameter_cache?.prevDate? response?.parameter_cache?.prevDate : null

            response = response.data;
            let responseTotal, minMaxData = null
            if (totalResponse && totalResponse.data) {
                setCacheFlag(tableResponseCache, totalResponse.data);
                responseTotal = totalResponse.data.result;
                minMaxData = totalResponse.data.minMaxData;
                if (minMaxData) {
                    var temp = addMinMaxDataToMetricDisp(that.props.selectedMetricDisp, minMaxData[0], nextProps.metricRange);
                    that.props && that.props.handleChange ? that.props.handleChange('metricDisp', temp) : '';
                }
            }
            if (response.data === null)
                response = 0;
            that.setState({
                table: response,
                cagrDate: cagrDate,
                previousPeriodDate: previousPeriodDate,
                category: nextProps.category,
                breakup: nextProps.breakUp,
                sum: responseTotal,
                metrics: nextProps.metrics,
                question: nextProps.question,
                questionId: nextProps.questionId,
                questionData: nextProps.questionData,
                periodComparison: nextProps.periodComparison,
                selectedMetric: nextProps.selectedMetric,
                drillDown: parsedResponse.drillDown,
                drillUp: parsedResponse?.drillUp,
                drillAcross: parsedResponse.drillAcross,
                sortOrder: that.props.sortOrder,
                period: nextProps.period,
                tablerendered: true,
                headers: headers,
                property_sort_order: property_sort_order,
                shortName: parsedResponse.shortName,
                shortNameKPI: shortNameKPI,
                kpiMonitoringCF: parsedResponse.kpiMonitoringCF,
                tableType: parsedResponse.tableType,
                sortRemoved : parsedResponse?.isSortTypeRemoved
            });
        }
        else {
            that.setState({
                table: 0
            })
        }
    }

    componentWillReceiveProps(nextProps) {
        var range = !this.state.i || !this.arePrevAndThisPropsEqual(this.props, nextProps);
        // var range = this.arePrevAndThisPropsEqual(this.props, nextProps) || first_handle;
        // first_handle=false;
        var indexedDB = this._db
        if (range) {
            var that = this;
            that.setState({
                table: null,
                drillHandle: nextProps.drillHandle,
                i: this.state.i + 1
            });
            var startDate = moment(nextProps.startDate, 'YYYY-MM-DD').format(dateFormatToSend1);
            var endDate = moment(nextProps.endDate, 'YYYY-MM-DD').format(dateFormatToSend2);
            var verifyEndDate = moment(nextProps.endDate).endOf('Month').format('YYYY-MM-DD');
            endDate = endDate > verifyEndDate ? verifyEndDate : endDate;
            var selectedMetric = nextProps.selectedMetric ? decodeURIComponent(nextProps.selectedMetric) : null;
            var periodComparison = nextProps.periodComparison ? nextProps.periodComparison : '';
            if ((nextProps.multiDim === false && nextProps.category && nextProps.category.includes(',')) || (nextProps.multiDim === undefined && nextProps.category && nextProps.category.includes(','))) {
                leftDim = nextProps.category.split(',')
                aboveDim = leftDim.pop()
            } else {
                leftDim = nextProps.category
                aboveDim = ""
            }
            if (selectedMetric && nextProps.metrics) {
                const dataSetDetails = JSON.parse(localStorage.Dataset)
                let sessionId = null, userId = null
                if (this.props.authData) {
                    sessionId = encodePassword(this.props.authData.sessionId)
                    userId = this.props.authData.userId
                }
                let sortOrder = nextProps.sortOrder ? nextProps.sortOrder : 'desc'
                let sortMetric = nextProps.sortMetric ? nextProps.sortMetric : null
                let cagrPoint = nextProps.cagrPoint ? nextProps.cagrPoint : null

                const authorization_value = "Basic " + base64.encode(encodePassword(userId) + ":");
                let params = {
                    siteId: dataSetDetails.siteId, toolId: nextProps.toolId ? nextProps.toolId : dataSetDetails.toolId, startDate: startDate, endDate: endDate, selectedProperty: refineURLData(nextProps.category), selectedPropertyValue: refineURLData(nextProps.categoryValue), breakUp: refineURLData(nextProps.breakUp), selectedMetric: refineURLData(selectedMetric), drill: refineURLData(nextProps.drill), period: refineURLData(nextProps.period), sortOrder: refineURLData(sortOrder),sortMetric:refineURLData(sortMetric), cagrPoint:refineURLData(cagrPoint), limit: refineURLData(nextProps.limit), insightType: refineURLData(nextProps.insightType), insightMetric: refineURLData(nextProps.insightMetric), metricRange: refineURLData(nextProps.metricRange), range: refineURLData(nextProps.metricRange), transpose: refineURLData(nextProps.transpose), multiDim: nextProps.multiDim === undefined && nextProps.propertyDisp.length >= 2 ? false : refineURLData(nextProps.multiDim), periodComparison: refineURLData(periodComparison), includeBreakUp: refineURLData(nextProps.include), excludeBreakUp: refineURLData(nextProps.exclude), summary: 0, chart: "Table", analysis: false, regressionLine: false, compare: false, dashboard: true, leftDim: leftDim ? refineURLData(leftDim.toString()) : '', aboveDim: refineURLData(aboveDim),removeGlobalFilter:nextProps?.removeGlobalFilter,prevStartDate:nextProps?.prevStartDate,prevEndDate:nextProps?.prevEndDate , ytdcagr:nextProps?.ytdcagr || nextProps?.ytdcagr || ""
                }
                if (nextProps.kpiMonitoring == true || nextProps.kpiMonitoring == 'true') {
                    params['kpiMonitoring'] = refineURLData(nextProps.kpiMonitoring)
                    params['kpiColumnConfig'] = refineURLData(nextProps.kpiColumnConfig)
                }
                // var selectedParam = []
                // let metricSelectedArray = selectedMetric.split(',')
                // metricSelectedArray?.map(function (innerMetric) {
                //     nextProps.metrics?.map(function (innerData) {
                //         if (`${innerData.value};${innerData.defaultFormula}` == innerMetric && innerData.information) {
                //             let parsedInfo = JSON.parse(innerData.information)
                //             if (parsedInfo.compare_based) {
                //                 selectedParam.push(innerMetric)
                //             }
                //         }
                //     })
                // })
                // if(selectedParam.length > 0) {
                //     params['compare'] = true
                //     params['selectedParam'] = selectedParam.join(',')
                // }
                let totalAjax = true
                let totalProppertyToUse = nextProps.category
                if (totalProppertyToUse) {
                    // let case1 = totalProppertyToUse.indexOf(';') != -1 // When property values are selected then make total row null  // commented case 1 because of total call not being made in case of property values
                    // let case2 = (totalProppertyToUse.split(',')).length > 1 && nextProps.multiDim == false // In case of cross tab make total row null
                    let case2 = refineURLData(nextProps.transpose) ? false : nextProps.transpose // In case of transpose make total row null
                    let case3 = refineURLData(nextProps.kpiMonitoring) ? false : nextProps.kpiMonitoring  //Incase of KPI Monitoring, make total row null
                    if ( case2 || case3 ) {
                        totalAjax = null
                    }
                }
                let parsedParams = JSON.parse(JSON.stringify(params))      // Deep copy of params
                let parsedDataSet = JSON.parse(JSON.parse(localStorage['persist:root']).dataSet).userDBSetting
                let totalRequired = parsedDataSet ? parsedDataSet[0].showChartSummary == 1 : true
                let totalParams = { ...parsedParams }
                if (totalAjax && totalRequired) {
                    // In case of crosstab total, don't touch the property and make crosstab total flag true
                    if (totalProppertyToUse) {
                        if ((totalProppertyToUse.split(',')).length > 1 && nextProps.multiDim == false) {
                            totalParams['crosstabTotal'] = true
                        }
                        totalParams['returnType'] = 'total';
                    }
                }
                let idbParams = parsedParams;
                idbParams['userId'] = userId;
                idbParams['globalFilters'] = nextProps.globalFilters
                idbParams['prevStartDate'] = nextProps?.prevStartDate
                idbParams['prevEndDate'] = nextProps?.prevEndDate
                let idbTotalParams = JSON.parse(JSON.stringify(totalParams))
                idbTotalParams['userId'] = userId;
                idbTotalParams['globalFilters'] = nextProps.globalFilters
                idbTotalParams['prevStartDate'] = nextProps?.prevStartDate
                idbTotalParams['prevEndDate'] = nextProps?.prevEndDate


                setCacheFlag([]);
                let checkIfCAGRQuestion = getParameters('question') ? typeof getParameters('question') === 'string' && (getParameters('question')?.includes('cagr')|| getParameters('question')?.includes('CAGR')):false;
                let checkIfSalienceQuestion = (getParameters('question') && typeof getParameters('question') === 'string' &&
                    getParameters('question')?.includes('salience')) ||
                    (nextProps?.selectedMetric &&
                        nextProps?.selectedMetric != null &&
                        nextProps.selectedMetric?.includes('percentageshare'));
                let checkIfSortLimitRangeTrue = !!(
                    (getParameters('metricRange') !== undefined && getParameters('metricRange') !== null && getParameters('metricRange') !== "null") ||
                    (
                        getParameters('sortOrder') !== undefined && getParameters('sortOrder') !== null && getParameters('sortOrder') !== "null" &&
                        getParameters('limit') !== undefined && getParameters('limit') !== null && getParameters('limit') !== "null"
                    )
                );

                var tableResponse, totalResponse = null, checkBooleanValue = (totalParams.transpose === "true" || totalParams.transpose === true || idbTotalParams.transpose === "true" || idbTotalParams.transpose === true || totalParams.kpiMonitoring == "true" || totalParams.kpiMonitoring == true || idbTotalParams.kpiMonitoring == "true" || idbTotalParams.kpiMonitoring == true  );
                if (totalAjax && totalRequired && checkBooleanValue === false && checkIfSortLimitRangeTrue === false && checkIfSalienceQuestion === false && checkIfCAGRQuestion == false && !selectedMetric?.includes('cagr')) {
                    indexedDB.get("Total_TableData", JSON.stringify(idbTotalParams)).then(e => {
                        if (e && e!=undefined) {
                            totalResponse = JSON.parse(e.object)
                        }
                    })
                }
                indexedDB.get("TableData", JSON.stringify(idbParams)).then(e => {
                    if (e && e!=undefined) {
                        tableResponse = e.object
                        var parsedTableResponse = JSON.parse(tableResponse)
                        var data = that.handleChartData(parsedTableResponse);
                        if (Object.keys(parsedTableResponse)) {
                            if (isEqual(Object.keys(minMaxDataGlobal), Object.keys(parsedTableResponse.minMaxData)) === true) {
                                delete params.metricRange;
                                delete params.range;
                                if (isEqual(localParams, params) === false) {
                                    localParams = params
                                    minMaxDataGlobal = parsedTableResponse.minMaxData;
                                }
                            } else if (isEqual(Object.keys(minMaxDataGlobal), Object.keys(parsedTableResponse.minMaxData)) === false) {
                                localParams = params
                                minMaxDataGlobal = parsedTableResponse.minMaxData;
                            }
                        }
                        that.stateSetFromResponse(data, totalResponse, nextProps, null)
                    } else {
                        if (totalAjax && totalRequired && checkBooleanValue === false && checkIfSortLimitRangeTrue === false && checkIfSalienceQuestion === false && !selectedMetric.includes('cagr') && checkIfCAGRQuestion === false) {
                            totalAjax = that.getAjaxRequest('summary', totalParams, authorization_value, sessionId)
                        }
                        // if (params.kpiMonitoring == true || params.kpiMonitoring == 'true') {
                        //     var tableAjax = that.postAjaxRequest('table', params, authorization_value, sessionId)
                        // } else {
                            var tableAjax = that.getAjaxRequest('table', params, authorization_value, sessionId)
                        // }
                        axios.all([tableAjax, totalAjax])
                            .then(axios.spread(function (tableResponse, totalResponse) { 
                                tableResponse.data = decodeResponseBody(tableResponse['data'])
                                totalResponse['data'] ? totalResponse.data = decodeResponseBody(totalResponse['data']) : null;
                                if(is500Error(totalResponse.data)) {
                                    that.setState({
                                        pageError: true,
                                        table: 0,
                                        response: totalResponse.data
                                    })
                                } else if (is500Error(tableResponse.data)) {
                                    that.setState({
                                        pageError: true,
                                        table: 0,
                                        response: tableResponse.data
                                    })
                                }
                                else if (tableResponse?.data?.status == false) {
                                    that.setState({
                                        pageError: true,
                                        table: 0,
                                        response: tableResponse?.data
                                    })
                                } else {
                                    var data = that.handleChartData(tableResponse.data);
                                    let tempParams = { ...params }
                                    if (Object.keys(tableResponse.data.minMaxData)) {
                                        if (isEqual(Object.keys(minMaxDataGlobal), Object.keys(tableResponse.data.minMaxData)) === true) {
                                            delete tempParams.metricRange;
                                            delete tempParams.range;
                                            delete localParams.metricRange;
                                            delete localParams.range;
                                            if (isEqual(localParams, tempParams) === false) {
                                                localParams = tempParams
                                                minMaxDataGlobal = tableResponse.data.minMaxData;
                                            }
                                        } else if (isEqual(Object.keys(minMaxDataGlobal), Object.keys(tableResponse.data.minMaxData)) === false) {
                                            localParams = params
                                            minMaxDataGlobal = tableResponse.data.minMaxData;
                                        }
                                    }
                                    var resultData = JSON.stringify(tableResponse.data)
                                    var totalResultData = JSON.stringify(totalResponse)
                                    indexedDB.put("TableData", resultData, JSON.stringify(idbParams))
                                    indexedDB.put("Total_TableData", totalResultData, JSON.stringify(idbTotalParams))
                                    that.stateSetFromResponse(data, totalResponse, nextProps, tableResponse.data['shortNameKPI'])
                                }                                
                            })).catch(error => {
                                if (error?.request?.status === 408) {
                                    alert("Session Timed Out. Please login again.");
                                    logoutHandle(true);
                                } else {
                                    alert(`${error?.response?.status}: Server Error, please try again later`);
                                }
                            });
                    }
                })
            } else {
                //atleast one metric is required condition
                this.setState({
                    table: 2
                })
            }
        } else {
            this.setState({
                tablerendered: false
            })
        }
    }
    handleChartData(tableData) {
        return { "table": JSON.stringify(tableData) }
    }
    render() {
        var metricDataToPass = null;
        var labelData = null;
        var property_sort_order = this.state.property_sort_order;
        // let isGlobalFilterRemoveFlag = this?.props?.removeGlobalFilter === null ? true : this?.props?.removeGlobalFilter === undefined ? true : this?.props?.removeGlobalFilter == false ? true : false
        if (this.state.table != null && this.state.metrics) {
            resetFilterGo();
            resetAppliedFilterFlag();
            if((this.props.pageError || this.state.pageError) && this.state.table == 0) {
                let is500 = this.state.response && this.state.response['error_code'] == 500 ? true : false                
                let information = this.state.response && this.state.response['information'] ? this.state.response['information'] : null
                let status = this.state?.response && this.state?.response?.['status'] ? this.state?.response?.['status'] : null
                return (<NoDataFound hideImg={true} is500={is500} status={status} information={information} response={this.state.response}/>);
            }
            else if (this.props.itemDetails && typeof this.props.itemDetails.parameters !== 'object' && IsJsonString(this.props.itemDetails.parameters) == false && this.state.table == 2)
                return (<NoDataFound hideImg={true} is500={true} />);
            else if (this.state.table == 0)
                return (<NoDataFound />);
            else if (this.state.table == 2)
                return (<NoDataFound data='Please set a filter with atleast 1 metric to view table' />);
            else if (this.state.table == 3)
                return (<NoDataFound data='Please set a filter only with 1 dimension to view table' />);
            else {
                var headers = this.state.headers;
                var transpose = this.props.transpose;
                var kpiMonitoring = this.props.kpiMonitoring;
                var label = Array();
                var reportPop;
                var link;
                var metricDataToPass;
                var multiDim = this.props.multiDim;
                multiDim = multiDim == undefined || multiDim == 'undefined' || !multiDim ? false : JSON.parse(multiDim);    // Convert 'true' to true and 'false' to false
                metricDataToPass = this.state.metrics;
                let isPropertyValue = this.props.category.indexOf(';') !== -1 ? true : false
                if (!isPropertyValue && (this.props.dashboard == 'insight' || this.props.propertyDisp.length >= 1)) {
                    if (multiDim) {
                        if (this.props.dashboard == 'insight') {
                            label = []
                            if (this.props.category) {
                                if (this.props.category == 'null') label = 'Label';
                                else {
                                    let tempLabel = this.props.category.split(',')
                                    tempLabel?.map(function (val) {
                                        val = val.replace('_', ' ');
                                        val = capitalizeFirstChar(val);
                                        label.push(val)
                                    })
                                }
                            }
                        } else {
                            let MultiDimension = this.props.propertyDisp[0].value.split(',');   // This is to consider multiDim from Dashboard
                            label = MultiDimension[1] ? MultiDimension : arrayColumn(this.props.propertyDisp, 'label');
                        }
                    } else {
                        if (this.props.dashboard == 'insight') {
                            label = this.props.category ? (this.props.category.split(',').length > 1 ? 'Label' : this.props.category) : []
                        } else if (this.props.propertyDisp.length >= 2) {
                            var leftdimDisplay = [...this.props.propertyDisp]
                            if (leftdimDisplay.length > 1) {
                                leftdimDisplay.pop()
                            }
                            label = arrayColumn(leftdimDisplay, 'label');
                        } else {
                            label = "Label"
                        }
                    }
                }
                else label = "Label";
                reportPop = false;
                link = false;
                    
                var property = this.state.category;
                var propertyCount = property ? (property.split(',')).length : 0;
                var preposition = 'by';
                if(propertyCount == 1 && property.split(';')[1]) {
                    preposition = property.split(';')[1] == 'overall' ? 'at' : 'for';
                }
                var detail1 = null;
                if (this.props.metricText && this.props.propertyText)
                    detail1 = this.props.metricText + " " + preposition + " " + this.props.propertyText;

                var detail2=[];
                var detail2_text='';
                const parsedData = JSON.parse(this.props?.dataset?.userDBSetting?.[0]?.information || '{}');
                const isFilterNew = parsedData?.filterInformation ? parsedData?.filterInformation : "0";
    
                if (this.props.breakupText) {
                    let breakupList = this.props?.breakUp.split(',');
    
                    detail2.push(<span>Filtered by {isFilterNew == '0' ?
                        breakupList?.map((item, index) => {
                            const [brand] = item.split(";"); // Split the string and take the first part
                            return <span class="badge badge-light tx-13 mg-2" >{brand}</span>;
                        })
                        : this.props.breakupText}</span>);
                    detail2_text += "Filtered by " + this.props.breakupText;
                    if (this.props.includeText || this.props.excludeText) {
                        detail2.push(<br />);
                    }
                    detail2_text += "<br>";
                }
                if (this.props.includeText) {
                    let includeList = this?.props?.include?.split(',');

                    detail2.push(<span>Included: {isFilterNew == '0' ?
                        includeList?.map((item, index) => {
                            const [brand] = item.split(";"); // Split the string and take the first part
                            return <span class="badge badge-light tx-13 mg-2" >{brand}</span>;
                        })
                        : this.props.includeText}</span>);
                    detail2_text += "Included: " + this.props.includeText;
                    if (this.props.excludeText) {
                        detail2.push(<br />);
                    }
                    detail2_text += "<br>";
                }
                if (this.props.excludeText) {
                    let excludeList = this?.props?.exclude?.split(',');

                    detail2.push(<span>Excluded: {isFilterNew == '0' ?
                        excludeList?.map((item, index) => {
                            const [brand] = item.split(";"); // Split the string and take the first part
                            return <span class="badge badge-light tx-13 mg-l-5" >{brand}</span>;
                        })
                        : this.props.excludeText}</span>);
                    detail2_text += "Excluded: " + this.props.excludeText;
                    // detail2.push(<br />);
                    detail2_text += "<br>";
                }

                var index = this.state.index ? this.state.index : 1;
                var dashboardDateInfo = null
                if (this.props.startDate && this.props.endDate && (index==1 || this.props.calendarStatus===true)){
                    if(granularity=="month")
                        var formatDateFunction = "MMMM, YYYY";//formatting the date time in description area
                    else var formatDateFunction = "MMMM DD, YYYY";//formatting the date time in description area
                    var detail3 = dashboardDateInfo = "Selected Date: " + moment(this.props.startDate,'YYYY-MM-DD').format(formatDateFunction) + " to " + moment(this.props.endDate,'YYYY-MM-DD').format(formatDateFunction);
                    if (this.props?.metric?.includes('cagr') || this.props?.selectedMetric?.includes('cagr')) {
                        var cagrDate = "CAGR Calculation Date: " + moment(this.state?.cagrDate?.startDate, 'YYYY-MM-DD').format(formatDateFunction) + " to " + moment(this.state?.cagrDate?.endDate, 'YYYY-MM-DD').format(formatDateFunction);
                    }
                    if(this.state.previousPeriodDate ){
                        var previousPeriodDisplayDate = "Compared Date: " + moment(this.state?.previousPeriodDate?.startDate?this.state?.previousPeriodDate?.startDate:this.props.prevStartDate, 'YYYY-MM-DD').format(formatDateFunction) + " to " + moment(this.state?.previousPeriodDate?.endDate?this.state?.previousPeriodDate?.endDate:this.state.prevEndDate, 'YYYY-MM-DD').format(formatDateFunction);

                    }
                }
                else
                    var detail3 = null;   
                    
                var sort = true;
                var sortOrder = null;
                if(!property_sort_order)    // property_sort_order is given for the dimension then don't sort the result by metric instead keep the result as it is.
                    sortOrder = this.props.sortOrder ? this.props.sortOrder : 'desc';
                if (this?.props?.insightType == 'true') {
                    var headers = this.state.table.headers;
                    metricDataToPass = typeof headers == 'string' ? jQuery.parseJSON(headers) : headers;
                    var sortMetric = '';
                    this.state.selectedMetric = '';
                }

                var sortMetric = null;
                if(!property_sort_order && is_sort_metric=='1'){    // property_sort_order is given for the dimension then don't sort the result by metric instead keep the result as it is.
                    if (this.state.selectedMetric)
                        sortMetric = this.state.selectedMetric.split(',')[0];
                }
                var globalFilter_details = null
                if (this.props.globalFilters && this.props.globalFilters.length > 0 && this?.props?.removeGlobalFilter != "true") {
                    globalFilter_details = getGlobalFilterDetails(this.props.globalFilters)
                }
                if (detail2) {
                    // ${detail1}<br></br>
                    var final_details_hover = `${detail3}<br>${detail2}`;
                    var final_details = (
                        <span
                            className={`tx-13 ${isFilterNew == '0' && this.props.globalFilters && this.props.globalFilters.length > 0 ? "" : "link-03"}`}
                            style={{ fontWeight: isFilterNew == '0' ? "bold" : "" }}
                        >
                            {this.props?.metric?.includes('cagr') || this.props?.selectedMetric?.includes('cagr') ? cagrDate : null}
                            {this.props?.metric?.includes('cagr') || this.props?.selectedMetric?.includes('cagr') ? <br /> : null}
                            {detail3}
                            {detail3 ? <br />
                                : null}
                            {previousPeriodDisplayDate}
                            {previousPeriodDisplayDate ? <br /> : null}
                            {detail2}
                            {detail2?.length > 0 ? <br /> : null}
                            {this.props.globalFilters && this.props.globalFilters.length > 0 && this?.props?.removeGlobalFilter != "true" ? "Global Filter: " : ""}
                            {isFilterNew == "0" && this.props.globalFilters && this.props.globalFilters.length > 0 && this?.props?.removeGlobalFilter!="true"? (
                                this.props.globalFilters?.map((innerdata) => (
                                    <span className="badge badge-info tx-13 mg-2" style={{ backgroundColor: "#ADD8E6", color: "black" }}>
                                        {innerdata.label}
                                    </span>
                                ))
                            ) : (
                                this.props?.globalFilters && this.props.globalFilters.length > 0 && this.props.removeGlobalFilter != "true" ? globalFilter_details : null
                            )}
                        </span>
                    );
                }
                else {
                    //<br>${detail1}
                    var final_details_hover = `${detail3}`;
                    var final_details = (
                        <span
                            className={`tx-13 ${isFilterNew == '0' && this.props.globalFilters && this.props.globalFilters.length > 0 ? "" : "link-03"}`}
                        >
                            {this.props?.metric?.includes('cagr') || this.props?.selectedMetric?.includes('cagr') ? cagrDate : null}
                            {this.props?.metric?.includes('cagr') || this.props?.selectedMetric?.includes('cagr') ? <br /> : null}
                            {previousPeriodDisplayDate}
                            {previousPeriodDisplayDate ? <br /> : null}
                            {detail3}
                            {this.props.globalFilters && this.props.globalFilters.length > 0  && this?.props?.removeGlobalFilter==false ? "Global Filter: " : ""}
                            {isFilterNew == "0" && this.props.globalFilters && this.props.globalFilters.length > 0 && this?.props?.removeGlobalFilter==false? (
                                this.props.globalFilters?.map((innerdata) => (
                                    <span className="badge badge-info tx-13 mg-2" style={{ backgroundColor: "#ADD8E6", color: "black" }}>
                                        {innerdata.label}
                                    </span>
                                ))
                            ) : (
                                globalFilter_details
                            )}
                        </span>
                    );
                    // <br/>{detail1}
                }
                if(dashboardDateInfo) {
                    dashboardDateInfo = <span className='tx-13 link-03'>{dashboardDateInfo}</span>;
                }
                var table_pad_to_apply = index>1?{paddingLeft:'0px',paddingright:'0px'}:{};
                                
                if((transpose == 'true' || transpose == true || kpiMonitoring == 'true' || kpiMonitoring == true) && (this.props.dashboard == 'insight' || this.props.propertyDisp.length==1 || this.props.propertyDisp.type == 'propertyLabel')) {
                    var tableCall = <TableComponent title={this.props.tableTitle} columnWidth={this.props.columnWidth} data={this.state.table} metrics={headers} showTotalRow={false} chartEnable={false}  label={label} final_details={final_details} final_details_hover={final_details_hover} tablerendered={true} index={index} transpose={transpose} dashboard_config={this.props.dashboard_config} dashboard={this.props.dashboard} selectedProperty={this.props.category} propertyDisp={this.props.propertyDisp} drillHandle={this.props.drillHandle} drillUp={this.state?.drillUp} drillDown={this.state.drillDown} drillAcross={this.state.drillAcross}
                    metricGlobal={this.props.mainMetric ? this.props.mainMetric : metricGlobal}
                    mainMetric={headers}
                    ExportComponentVar={this.props.ExportComponentVar}
                    componentData={this.props}
                    kpiMonitoring={kpiMonitoring}
                    shortName={this.state.shortName}
                    shortNameKPI={this.state.shortNameKPI}
                    kpiMonitoringCF={this.state.kpiMonitoringCF}
                    dashboardDateInfo={dashboardDateInfo}
                    report_type={this.props.report_type}
                    tableType={this.state.tableType}
                    removeGlobalFilter={this.props.removeGlobalFilter}

                    />;
                    
                } else {
                    if(transpose=="true" && this.props.propertyDisp.length>1)
                        sortMetric=null;
                    var tableCall = <TableComponent title={this.props.tableTitle} columnWidth={this.props.columnWidth} data={this.state.table} mainHeaders={headers} metrics={metricDataToPass} selectedMetric={this.state.selectedMetric} selectedProperty={this.props.category} propertyDisp={this.props.propertyDisp} drillHandle={this.props.drillHandle} drillUp={this.state?.drillUp} drillDown={this.state.drillDown} report={true} pop={reportPop} sum={this.state.sum} label={label} link={link} sort={sort} sortOrder={sortOrder} sortMetric={sortMetric} drillAcross={this.state.drillAcross} period={this.state.period} tablerendered={this.state.tablerendered} index={index} transpose={transpose} multiDim={multiDim} final_details={final_details} final_details_hover={final_details_hover} shortenHandle={this.props.shortenHandle}
                    property_multi_flag={this.props.property_multi_flag}  crosstab_flag={this.props.crosstab_flag} enable_multi_dimension_title={this.props.enable_multi_dimension_title} enable_crosstab_title={this.props.enable_crosstab_title} dashboard_config={this.props.dashboard_config} dashboard={this.props.dashboard}
                    mainMetric={this.props.mainMetric ? this.props.mainMetric : metricGlobal}
                    ExportComponentVar={this.props.ExportComponentVar}
                    componentData={this.props}
                    kpiMonitoring={kpiMonitoring}
                    shortName={this.state.shortName}
                    shortNameKPI={this.state.shortNameKPI}
                    dashboardDateInfo={dashboardDateInfo}
                    report_type={this.props.report_type}
                    tableType={this.state.tableType}
                    isSortRemoved={this.state.sortRemoved}
                    removeGlobalFilter={this.props.removeGlobalFilter}
                    dashboardLayout={this.props?.dashboardLayout || null}

                    />;                    
                }

                return (<div className="col-md-12 pd-x-0" style={table_pad_to_apply}>
                    {tableCall}
                </div>);
            }
        }
        return (<LoadingComponent />);
    }
};

export default TableData;